export interface IPatient {
    firstName: string;
    lastName: string;
    sex: string;
    birthDate: Date;
}

export function isPatient(object: any): object is IPatient {
    return 'firstName' in object && 'lastName' in object;
}
